var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NGXLogger } from 'ngx-logger';
import { AuAction } from '../../action/au.action';
import { MessageService } from '../../service/message.service';
import { PageService } from '../../models/page.service';
import { ContentBaseComponent } from '../base/contentbase.component';
import { ContentBaseService } from '../../component/base/contentbase.service';
var ImportErrorComponent = /** @class */ (function (_super) {
    __extends(ImportErrorComponent, _super);
    function ImportErrorComponent(router, route, logger, action, message, page, service) {
        var _this = _super.call(this, router, route, logger, action, message, page, service) || this;
        _this.router = router;
        _this.route = route;
        _this.logger = logger;
        _this.action = action;
        _this.message = message;
        _this.page = page;
        _this.service = service;
        _this.errorInfo = [];
        return _this;
    }
    ImportErrorComponent.prototype.ngOnInit = function () {
        _super.prototype.ngOnInit.call(this);
        if (this.component.params && this.component.params.mode) {
            this.mode = this.component.params.mode;
        }
    };
    ImportErrorComponent.prototype.onInit = function (meta) {
        _super.prototype.onInit.call(this, meta);
        console.log('onInit');
    };
    ImportErrorComponent.prototype.setUnsubscribe = function () {
        this.eventSubscription.unsubscribe();
        this.changeSubscription.unsubscribe();
    };
    ImportErrorComponent.prototype.onModeSubscribe = function (mode) {
        this.mode = mode;
    };
    ImportErrorComponent.prototype.onSubscribe = function (data) {
        var errJson = JSON.parse(data['error_info']);
        var i = 0;
        for (var err in errJson) {
            this.errorInfo.push(errJson[i]['error_code']);
            i++;
        }
    };
    // @Override
    ImportErrorComponent.prototype.onEvent = function (e1, e2, rec) {
    };
    ImportErrorComponent.prototype.ngOnDestroy = function () {
        _super.prototype.ngOnDestroy.call(this);
    };
    ImportErrorComponent.decorators = [
        { type: Component, args: [{
                    moduleId: module.id.toString(),
                    selector: 'import',
                    template: "<dl class=\"form -mt-3\"></dl>\n<div *ngIf=\"errorInfo.length > 0\">\n  <div class=\"col-sm-12\">\n    <dl class=\"form\">\n      <dt class=\"form_dt\">\n        <column-formtitle [key]=\"'form'\" [col]=\"{label: (msg | async)['au.COMPONENT.ImportErrorComponent.label.error_info']}\" [msg]=\"(msg | async)\"></column-formtitle>\n      </dt>\n    </dl>\n    <dl class=\"form -mb-3\">\n      <dd class=\"form_dd\">\n        <ul>\n          <li *ngFor=\"let errorMsg of errorInfo\">\n            <div class=\"formError\">{{ errorMsg }}</div>\n          </li>\n        </ul>\n      </dd>\n    </dl>\n  </div>\n</div>\n"
                }] }
    ];
    /** @nocollapse */
    ImportErrorComponent.ctorParameters = function () { return [
        { type: Router },
        { type: ActivatedRoute },
        { type: NGXLogger },
        { type: AuAction },
        { type: MessageService },
        { type: PageService },
        { type: ContentBaseService }
    ]; };
    return ImportErrorComponent;
}(ContentBaseComponent));
export { ImportErrorComponent };
//# sourceMappingURL=import-error.component.js.map